<template>
    <input
    type="checkbox"
    :indeterminate.prop="isIndeterminate"
    :class="[{ indeterminate: isIndeterminate}, classes]"
    :checked="isChecked"
    @change="toggle"
    />
</template>

<script>
export default {
props: {
    value: {
        type: [Boolean, null],
        default: false
    },
    classes: {
        type: String,
        default: ''
    }
},
computed: {
    isChecked() {
        return this.value === true;
    },
    isIndeterminate() {
        return this.value === null;
    }
},
    mounted() {
        this.updateIndeterminateState();
    },
    watch: {
        value() {
        this.updateIndeterminateState();
        }
    },
    methods: {
        updateIndeterminateState() {
            this.$nextTick(() => {
                if (this.$refs.checkbox) {
                    this.$refs.checkbox.indeterminate = this.isIndeterminate;
                }
            });
        },
        toggle(event) {
            event.preventDefault();
            let newValue = this.value === null ? true : this.value === true ? false : null;
            
            this.$emit('input', newValue);
            this.updateIndeterminateState();
        }
    }
};
</script>

<style scoped>
    /* Estilo padrão da checkbox */
    input[type="checkbox"] {
        width: 18px;
        height: 18px;
    }
</style>


// WEBPACK FOOTER //
// Checkbox.vue?7800f318